import React from "react";

class Pagination extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      goToPageInputValue: "",
      goToButtonDisabled: false,
    };
    this.handlePageClick = this.handlePageClick.bind(this);
    this.handleEllipsisClick = this.handleEllipsisClick.bind(this);
    this.handleGotoPage = this.handleGotoPage.bind(this);
    this.handleArrowClick = this.handleArrowClick.bind(this);
    this.buildPageButton = this.buildPageButton.bind(this);
    this.buildEllipsis = this.buildEllipsis.bind(this);
    this.buildArrowNavigation = this.buildArrowNavigation.bind(this);
    this.buildPagination = this.buildPagination.bind(this);
  }

  handlePageClick(page) {
    if (page != this.props.currentPage) {
      this.props.onPageChange(parseInt(page, 10));
    }
  }

  handleEllipsisClick(page) {
    this.props.onPageChange(page);
  }

  handleGotoPage(ev) {
    ev.preventDefault();
    const value = this.state.goToPageInputValue;

    this.handlePageClick(value);
  }

  handleGoToInputChange(e) {
    const value = e.target.value;
    const outOfBounds = value > this.props.totalPages || value <= 0;

    this.setState({
      ...this.state,
      goToPageInputValue: value,
      goToButtonDisabled: outOfBounds,
    });
  }

  handleArrowClick(direction) {
    var targetPage =
      direction == "next"
        ? this.props.currentPage + 1
        : this.props.currentPage - 1;
    if (targetPage <= this.props.totalPages && targetPage > 0) {
      this.props.onPageChange(targetPage);
    }
  }

  render() {
    if (this.props.totalPages <= 1) return <span />;

    return (
      <>
        <div style={{ marginRight: "1em" }}>
          <nav className="btn-group">{this.buildPagination()}</nav>
        </div>

        <div
          className="col-sm-3 col-lg-2"
          style={{ width: "20ch", marginBottom: "5px" }}
        >
          <div className="input-group">
            <input
              onChange={this.handleGoToInputChange.bind(this)}
              type="number"
              min="1"
              max={this.props.totalPages}
              className="form-control"
              placeholder="Page"
              value={this.state.goToPageInputValue}
            />
            <span className="input-group-btn">
              <button
                type="button"
                disabled={this.state.goToButtonDisabled}
                className="btn btn-default"
                onClick={this.handleGotoPage}
              >
                Go
              </button>
            </span>
          </div>
        </div>
      </>
    );
  }

  buildPageButton(value) {
    return (
      <button
        key={"pageButton-" + value}
        disabled={this.props.disabled}
        className={
          "btn " +
          (value == this.props.currentPage
            ? "btn-primary"
            : "btn-default hidden-xs")
        }
        onClick={this.handlePageClick.bind(null, value)}
      >
        {value}
      </button>
    );
  }

  buildEllipsis(side, value) {
    return (
      <button
        key={"page-ellipsis-" + side}
        disabled={this.props.disabled}
        className="btn btn-default hidden-xs"
        onClick={this.handleEllipsisClick.bind(null, value)}
      >
        &hellip;
      </button>
    );
  }

  buildArrowNavigation(direction, total) {
    var disabled = "",
      icon = "";

    if (direction == "previous") {
      // icon = 'Prev.';
      icon = (
        <span>
          <span className="hidden-xs">&lt;</span>
          <span className="visible-xs">Previous</span>
        </span>
      );
      if (this.props.currentPage == 1) disabled = "disabled";
    }

    if (direction == "next") {
      // icon = 'Next';
      icon = (
        <span>
          <span className="hidden-xs">&gt;</span>
          <span className="visible-xs">Next</span>
        </span>
      );
      if (this.props.totalPages && this.props.totalPages <= this.props.per) {
        disabled = "disabled";
      }
    }

    return (
      <button
        key={"page-arrow-" + direction}
        disabled={this.props.disabled}
        className={"btn btn-default " + direction + " " + disabled}
        onClick={this.handleArrowClick.bind(null, direction)}
      >
        {icon}
      </button>
    );
  }

  buildPagination() {
    var MAX_BUTTONS = 5;
    var pages = this.props.totalPages,
      navigation = [];

    if (pages > 1) {
      if (pages < MAX_BUTTONS) {
        for (var i = 1; i <= pages; i++) {
          navigation.push(this.buildPageButton(i));
        }
      } else {
        var start = MAX_BUTTONS - 2,
          end = pages - (MAX_BUTTONS - 3);

        if (this.props.currentPage > start && this.props.currentPage < end) {
          // !A_!Z, Pad Both

          navigation.push(this.buildPageButton(1));
          navigation.push(
            this.buildEllipsis("left", this.props.currentPage - 2)
          );

          for (
            var a = this.props.currentPage - 1;
            a <= this.props.currentPage + 1;
            a++
          ) {
            navigation.push(this.buildPageButton(a));
          }

          navigation.push(
            this.buildEllipsis("right", this.props.currentPage + 2)
          );
          navigation.push(this.buildPageButton(pages));
        } else if (this.props.currentPage <= start) {
          // A_!Z, Pad Right

          for (var b = 1; b <= MAX_BUTTONS - 2; b++) {
            navigation.push(this.buildPageButton(b));
          }

          navigation.push(this.buildEllipsis("right", MAX_BUTTONS - 1));
          navigation.push(this.buildPageButton(pages));
        } else if (this.props.currentPage >= end) {
          // !A_Z, Pad Left

          navigation.push(this.buildPageButton(1));
          navigation.push(
            this.buildEllipsis("left", pages - (MAX_BUTTONS - 1))
          );

          for (var c = pages - (MAX_BUTTONS - 3); c <= pages; c++) {
            navigation.push(this.buildPageButton(c));
          }
        }
      }

      navigation.unshift(this.buildArrowNavigation("previous", pages));
      navigation.push(this.buildArrowNavigation("next", pages));
    }

    return navigation;
  }
}

export default Pagination;
